export default function GeneratorHeroIllustration() {
  return (
    <svg className="illustration" width="120" height="96" viewBox="0 0 120 96" fill="none">
      <rect x="20" y="14" width="52" height="68" rx="6" fill="var(--accent-bg)" stroke="var(--accent)" strokeWidth="1.5" />
      <rect x="30" y="28" width="32" height="3.5" rx="1.75" fill="var(--accent)" opacity="0.55" />
      <rect x="30" y="38" width="32" height="3.5" rx="1.75" fill="var(--accent)" opacity="0.4" />
      <rect x="30" y="48" width="22" height="3.5" rx="1.75" fill="var(--accent)" opacity="0.4" />
      <rect x="30" y="60" width="26" height="8" rx="4" fill="var(--ai-gradient)" />
      <circle cx="86" cy="26" r="14" fill="var(--brand-red-bg)" stroke="var(--brand-red)" strokeWidth="1.5" />
      <path d="M86 19v14M79 26h14" stroke="var(--brand-red)" strokeWidth="2" strokeLinecap="round" />
      <path d="M96 62l4 4-4 4M92 66h8" stroke="var(--accent)" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" opacity="0.7" />
    </svg>
  );
}
